import { makeStyles } from '@branchjs/neo-components';

export const useStyles = makeStyles((theme) => ({
  card: {
    height: '520px',
    width: '615px',
    borderRadius: '8px',
  },
  cardContent: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    textAlign: 'center',
    margin: '32px 48px 56px',
  },
  cardTitle: {
    ...theme.typography.h3,
    paddingBottom: 36,
    color: theme.colors.primary.main,
  },
  image: {
    alignSelf: 'center',
    marginBottom: '24px',
  },
  verifyEmailTextBlock: {
    width: '435px',
    alignSelf: 'center',
  },
  mainText: {
    ...theme.typography.body1,
    color: theme.colors.gray[800],
  },
  emailInBold: {
    fontWeight: '600',
  },
  checkSpamTextBlock: {
    paddingTop: '24px',
    paddingBottom: '36px',
  },
  linkColor: {
    color: theme.colors.primary.main,
  },
  footer: {
    fontSize: theme.typography.body2.fontSize,
  },
}));
